
import Links from '@library/components/Atoms/Link/Links.vue'
export default {
  name: 'SideNavLanguage',
  components: {Links},
  data: () => ({}),
  props: {
    langDefault: {
      type: String,
      default: ''
    },
    languages: {
      type: Array,
      default: () => []
    },
    activeMenu: {
      type: Boolean,
      default: false
    },
    publicPath: {
      type: String,
      default: '/'
    },
    isKiosk: {
      type: Boolean,
      default: false
    },
    labels: {
      type: Object,
      default: () => {}
    },
    terminalId: {
      type: String,
      default: ''
    },
    hotelId: {
      type: String,
      default: ''
    }
  },
  computed: {
    isDropdown() {
      return this.languages && this.languages.length
    }
  },
  methods: {
    isChecked(lang) {
      return lang && this.langDefault ? lang.toLowerCase() === this.langDefault.toLowerCase() : false
    },
    changeLanguage(lang) {
      this.$emit('changeLanguage', lang)
    },
    parseUrl(url) {
      if (url?.linkUrl) {
        return url.linkUrl
      } else if (url?.langCode) {
        return `/${url?.langCode?.toLowerCase()}`
      } else {
        return 'javascript:void(0)'
      }
    }
  }
}
